import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { QuestOrderCode } from '../../models/quest-order-code';

const getOtherQuestOrderCodeIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<QuestOrderCode>) => memoize((
        ids: Undefinable<string>[]
    ) => ids.filter(x => x && !byId[x]) as string[])
);

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getOtherQuestOrderCodeIds: (
        state: State,
        ids: Undefinable<string>[]
    ): string[] => getOtherQuestOrderCodeIdsSelector(state)(ids),
    getQuestOrderCode: (
        state: State,
        id: Undefinable<string>
    ): Undefinable<QuestOrderCode> => state.byId[id || '']
};
